import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { RevelationSection } from './components/RevelationSection';
import { InterventionSection } from './components/InterventionSection';
import { OfferSection } from './components/OfferSection';
import { BonusSection } from './components/BonusSection';
import { MockupSection } from './components/MockupSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ClosingSection } from './components/ClosingSection';
export function App() {
  return <main className="min-h-screen bg-white font-sans" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <RevelationSection data-id="element-3" />
      <InterventionSection data-id="element-4" />
      <OfferSection data-id="element-5" />
      <BonusSection data-id="element-6" />
      <MockupSection data-id="element-7" />
      <TestimonialsSection data-id="element-8" />
      <ClosingSection data-id="element-9" />
    </main>;
}